import {useIntl} from 'react-intl'

export function LoadingState() {
  const intl = useIntl()

  return (
    <div
      className='gori-signature-results d-flex align-items-center justify-content-center min-vh-100'
      role='main'
      aria-live='polite'
      aria-busy='true'
    >
      <div className='text-center'>
        <img
          src='/media/gori/gori-signature/reload.svg'
          alt='Loading'
          style={{width: '80px', height: '80px', animation: 'spin 2s linear infinite'}}
          aria-hidden='true'
        />
        <p className='fs-4 text-dark mt-4'>{intl.formatMessage({id: 'GORI_SIGNATURE_LOADING'})}</p>
      </div>
    </div>
  )
}
LoadingState.displayName = 'LoadingState'
